import { Component } from '@angular/core';

@Component({
  selector: 'app-claim-page',
  templateUrl: './claim-page.component.html',
  styleUrls: ['./claim-page.component.scss'],
  standalone: false
})
export class ClaimPageComponent {
  constructor() {}
}
